/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description Commodité du bien — libellés et compatibilité avec la nature dans form-rules/property-form.json (champ commodities)
 */
export const propertyCommodityCodeSchema = z.enum(["TRAIN_STATION", "SCHOOL", "SHOP", "METRO", "TOWN_CENTER", "BUS", "TRAM", "SERVICES", "SEA", "MOUNTAIN"]).describe("Commodité du bien — libellés et compatibilité avec la nature dans form-rules/property-form.json (champ commodities)")